import * as $ from 'jquery';

const settings = {
	discountCodeInput: '.js-discount-code-input',
	discountCodeSubmit: '.js-discount-code-submit',
	discountCodeMessage: '.js-discount-code-message',
};

export const init = () => {
	$(settings.discountCodeSubmit).click(function(e) {
		e.preventDefault();
		e.stopPropagation();
		e.stopImmediatePropagation();
		applyCode($(settings.discountCodeInput).val());
		return false;
	});
}

function applyCode(code) {
	$.ajax('/ajax/booking/apply_code', {
		method: 'POST',
		data: {
			code
		},
		success: (response) => {
			const data = JSON.parse(response);

			$(document).trigger('updatePrices', {
				total: data.data.total_price_formatted,
				deposit: data.data.deposit ? data.data.deposit_price_formatted : '',
			});

			$(settings.discountCodeMessage)
				.text(data.message)
				.removeClass('text-danger text-success')
				.addClass(data.success ? 'text-success' : 'text-danger');
		},
		error: (xhr, status, error) => {
			$(settings.discountCodeMessage)
				.text('There was a problem submitting the discount code. Please refresh the page and try again.')
				.removeClass('text-danger text-success')
				.addClass('text-danger');
		}
	});
}

init();
